/**
 * Zwei-Finger-Zoom unterbinden — damit die Oberfläche immer vollständig ins
 * Display passt und nicht verschoben werden kann.
 *
 * Es braucht mehrere Riegel, weil kein einzelner überall greift:
 *
 *  1. `user-scalable=no` im Viewport (index.html) — daran hält sich die
 *     installierte App auf dem Startbildschirm, Safari im Browser nicht.
 *  2. `touch-action: pan-x pan-y` im Stylesheet — greift in Chrome und
 *     Android und nimmt den Doppeltipp-Zoom mit.
 *  3. Safaris eigene Gesten-Ereignisse (`gesturestart` …) — der Weg, der im
 *     Browser wirkt.
 *  4. Und dieser hier: jede Berührung mit mehr als einem Finger wird
 *     abgebrochen. Das ist der einzige Riegel, der unabhängig von Browser,
 *     Fassung und Betriebsart hält — deshalb ist er der wichtigste.
 *
 * Wichtig: Nur `touchmove` wird abgefangen, nicht `touchstart`. Ein
 * unterdrücktes touchstart würde auch das anschließende Antippen schlucken,
 * und mit einem Finger soll sich die Seite weiterhin normal scrollen lassen.
 * Das Unterschriftsfeld bleibt unberührt, es zeichnet mit einem Finger.
 */
export function zoomSperren() {
  // Mehrfinger-Bewegung: kein Zoom, kein Verschieben.
  document.addEventListener(
    'touchmove',
    (ereignis) => {
      if (ereignis.touches.length > 1) ereignis.preventDefault()
    },
    { passive: false }
  )

  // Safari kennt zusätzlich eigene Gesten-Ereignisse.
  for (const name of ['gesturestart', 'gesturechange', 'gestureend']) {
    document.addEventListener(name, (ereignis) => ereignis.preventDefault(), { passive: false })
  }

  // Sollte trotz allem einmal gezoomt worden sein (etwa durch die
  // Bedienungshilfen), holt das die Ansicht beim Loslassen zurück.
  document.addEventListener('touchend', () => {
    if (window.visualViewport && window.visualViewport.scale > 1.01) {
      window.scrollTo(window.scrollX, window.scrollY)
    }
  })
}
